// eslint-disable-next-line no-restricted-imports
import { Card, Stack, Text } from '@mantine/core';

type EmptyStateProps = {
  icon?: JSX.Element;
  title?: string;
  description?: string;
  cta?: JSX.Element;
};

/** @deprecated - Used for old commish hub */
export function EmptyState({ icon, title, description, cta = null }: EmptyStateProps) {
  return (
    <Card p="xl" radius="sm">
      <Stack w="100%" maw={768} mx="auto" py="xl">
        <Stack align="center" py="xl">
          {icon}
          <Text align="center" size={26} fw={700}>
            {title}
          </Text>
          <Text>{description}</Text>
          {cta}
        </Stack>
      </Stack>
    </Card>
  );
}
